import React from "react";
import ReactDOM from "react-dom";
import "bootstrap/dist/css/bootstrap.css";
import "./assets/scss/paper-dashboard.scss";
import "./assets/demo/demo.css";
import App from "./AppWithAuth";

ReactDOM.render(<App />, document.getElementById('root'));

